import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import ServicesLanding from "../views/ServicesLanding";
import LoansDetailed from "../views/LoansDetails";
import SavingsDepositsDetailed from "../views/SavingsDepositsDetails";


export default function Services(props) {

	const appContext = useContext(AppContext);

	const [ view, setView ] = useState(null);

	async function init() {
		//run initializations here
	}

	function getView() {
		if(
			!appContext.navSubItem &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <ServicesLanding/>
		} else if (
			appContext.navSubItem === "loans" &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <LoansDetailed />
		} else if (
			appContext.navSubItem === "savings_deposits" &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <SavingsDepositsDetailed />
		}

		return null;
	}

	useEffect(() => {
		init();
	}, [ ])

	useEffect(() => {
		const _view = getView();
		if(_view) {
			setView(_view);
		}
	}, [ appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem ])

	//return desired view
	return view;
}